import _ from "lodash";

interface ConfigurableService {
    id: number;
    name: string;
    description: string;
    enabled: boolean;
    maxQuantity?: string;
    max_quantity?: string;
}

interface ServicioMegaMovil {
    servicio: string;
    tipo_linea: string;
}

interface ResponsePackageItem {
    packageType: string;
    clasificacionMega?: string;
    servicios?: ServicioMegaMovil[];
}

interface HireMegaMovilConfig {
    limitToOne: boolean;
    showCurp: boolean;
    showBusinessFields: boolean;
    max: number;
    showLineTypeSelector: boolean;
    familyLineDefinitions: ServicioMegaMovil[];
}

const CONFIGURABLE_SERVICE_NAMES = {
    ACTIVATE_MEGAMOVIL_RESIDENTIAL_DATA: "ACTIVATE_MEGAMOVIL_RESIDENTIAL_DATA",
    ACTIVATE_MEGAMOVIL_BUSINESS_DATA: "ACTIVATE_MEGAMOVIL_BUSINESS_DATA",
    ACTIVATE_QTY_INDIVIDUAL_PLANS: "ACTIVATE_QTY_INDIVIDUAL_PLANS",
    ACTIVATE_SIM_ESIM_INDIVIDUAL_PLANS: "ACTIVATE_SIM_ESIM_INDIVIDUAL_PLANS",
    ACTIVATE_SIM_ESIM_FAMILY_PLANS: "ACTIVATE_SIM_ESIM_FAMILY_PLANS",
    MAX_QUANTITY_INDIVIDUAL_RESIDENTIAL: "MAX_QUANTITY_INDIVIDUAL_RESIDENTIAL",
    MAX_QUANTITY_INDIVIDUAL_BUSINESS: "MAX_QUANTITY_INDIVIDUAL_BUSINESS",
} as const;

const getConfiguredMaxQuantity = (config?: ConfigurableService): number => {
    const rawQuantity = config?.maxQuantity ?? config?.max_quantity ?? "0";
    const parsedQuantity = Number.parseInt(rawQuantity, 10);
    return Number.isNaN(parsedQuantity) ? 0 : parsedQuantity;
};

export const getHireMegaMovilConfig = (
    service: ResponsePackageItem,
    confServiceData: ConfigurableService[]
): HireMegaMovilConfig => {
    const getServiceConfig = (name: string) => (
        _.find<ConfigurableService>(confServiceData, { name })
    );

    const enableResidencial = getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.ACTIVATE_MEGAMOVIL_RESIDENTIAL_DATA
    )?.enabled;
    const enableBusiness = getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.ACTIVATE_MEGAMOVIL_BUSINESS_DATA
    )?.enabled;
    const enableIndividual = getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.ACTIVATE_QTY_INDIVIDUAL_PLANS
    )?.enabled;
    const enableSimEsimIndividual = getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.ACTIVATE_SIM_ESIM_INDIVIDUAL_PLANS
    )?.enabled;
    const enableSimEsimFamily = getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.ACTIVATE_SIM_ESIM_FAMILY_PLANS
    )?.enabled;

    const maxResidential = getConfiguredMaxQuantity(getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.MAX_QUANTITY_INDIVIDUAL_RESIDENTIAL
    ));
    const maxBusiness = getConfiguredMaxQuantity(getServiceConfig(
        CONFIGURABLE_SERVICE_NAMES.MAX_QUANTITY_INDIVIDUAL_BUSINESS
    ));

    const isFamilyPackage = service.packageType === "FAMILIAR";
    const isIndividualPackage = service.packageType === "INDIVIDUAL";
    const limitToOne = Boolean(isFamilyPackage || (enableIndividual && isIndividualPackage));

    const showCurp = Boolean(enableResidencial && service.clasificacionMega === "RESIDENCIAL");
    const showBusinessFields = Boolean(enableBusiness && service.clasificacionMega === "EMPRESARIAL");
    const max = limitToOne
        ? 1
        : service.clasificacionMega === "RESIDENCIAL"
            ? maxResidential
            : maxBusiness;
    const showLineTypeSelector = isFamilyPackage
        ? Boolean(enableSimEsimFamily)
        : Boolean(isIndividualPackage && enableSimEsimIndividual);

    return {
        limitToOne,
        showCurp,
        showBusinessFields,
        max,
        showLineTypeSelector,
        familyLineDefinitions: isFamilyPackage ? (service.servicios ?? []) : [],
    };
};
